var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "is-loop-container" }, [
    _c("div", { staticClass: "header" }, [
      _c("h3", { staticClass: "mb-3" }, [_vm._v("IS Loop Paths")]),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c(
            "base-btn",
            {
              staticClass: "mr-2",
              attrs: { disabled: _vm.loading },
              on: { click: _vm.fetchLocationPaths },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("mdi-refresh")]),
              _vm._v(" " + _vm._s(_vm.loading ? "Reloading…" : "Reload") + " "),
            ],
            1
          ),
          _c(
            "base-btn",
            {
              staticClass: "mr-2",
              attrs: {
                disabled: _vm.loading || !_vm.locationPathResult?.paths?.length,
              },
              on: { click: _vm.expandAll },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [
                _vm._v("mdi-arrow-expand-vertical"),
              ]),
              _vm._v(" Expand All "),
            ],
            1
          ),
          _c(
            "base-btn",
            {
              attrs: {
                disabled: _vm.loading || !_vm.locationPathResult?.paths?.length,
              },
              on: { click: _vm.collapseAll },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [
                _vm._v("mdi-arrow-collapse-vertical"),
              ]),
              _vm._v(" Collapse All "),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm.loading
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [
            _c("v-progress-circular", {
              attrs: { indeterminate: "", color: "primary", size: "64" },
            }),
            _c("p", { staticClass: "mt-3" }, [
              _vm._v("Loading location paths..."),
            ]),
          ],
          1
        )
      : !_vm.locationPathResult ||
        !_vm.locationPathResult.paths ||
        _vm.locationPathResult.paths.length === 0
      ? _c(
          "div",
          { staticClass: "empty-state" },
          [
            _c("v-icon", { attrs: { size: "64", color: "grey lighten-1" } }, [
              _vm._v("mdi-alert-circle-outline"),
            ]),
            _c("p", { staticClass: "mt-3" }, [_vm._v("No paths found")]),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "v-card",
              { staticClass: "summary-card mb-3", attrs: { elevation: "1" } },
              [
                _c(
                  "v-card-title",
                  { staticClass: "primary white--text py-2" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { color: "white", small: "" },
                      },
                      [_vm._v("mdi-chart-box-outline")]
                    ),
                    _c("span", { staticClass: "text-subtitle-1" }, [
                      _vm._v("Summary"),
                    ]),
                  ],
                  1
                ),
                _c(
                  "v-card-text",
                  { staticClass: "pa-3" },
                  [
                    _c(
                      "v-row",
                      { attrs: { dense: "" } },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "4", md: "2" } },
                          [
                            _c("div", { staticClass: "summary-item" }, [
                              _c("div", { staticClass: "summary-label" }, [
                                _vm._v("Total Paths"),
                              ]),
                              _c("div", { staticClass: "summary-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.locationPathResult.summary.totalPaths
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "4", md: "2" } },
                          [
                            _c("div", { staticClass: "summary-item" }, [
                              _c("div", { staticClass: "summary-label" }, [
                                _vm._v("Dist. Panels"),
                              ]),
                              _c("div", { staticClass: "summary-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.locationPathResult.summary
                                      .totalDistributionPanels
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "4", md: "2" } },
                          [
                            _c("div", { staticClass: "summary-item" }, [
                              _c("div", { staticClass: "summary-label" }, [
                                _vm._v("Leaf Nodes"),
                              ]),
                              _c("div", { staticClass: "summary-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.locationPathResult.summary
                                      .totalLeafNodes
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "4", md: "2" } },
                          [
                            _c("div", { staticClass: "summary-item" }, [
                              _c("div", { staticClass: "summary-label" }, [
                                _vm._v("Avg Depth"),
                              ]),
                              _c("div", { staticClass: "summary-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.locationPathResult.summary.averagePathDepth.toFixed(
                                      2
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "4", md: "2" } },
                          [
                            _c("div", { staticClass: "summary-item" }, [
                              _c("div", { staticClass: "summary-label" }, [
                                _vm._v("Max Depth"),
                              ]),
                              _c("div", { staticClass: "summary-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.locationPathResult.summary.maxPathDepth
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6", sm: "4", md: "2" } },
                          [
                            _c("div", { staticClass: "summary-item" }, [
                              _c("div", { staticClass: "summary-label" }, [
                                _vm._v("Min Depth"),
                              ]),
                              _c("div", { staticClass: "summary-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.locationPathResult.summary.minPathDepth
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "paths-list" },
              [
                _c("h4", { staticClass: "mb-3" }, [
                  _vm._v(
                    "All Paths (" +
                      _vm._s(_vm.locationPathResult.paths.length) +
                      ")"
                  ),
                ]),
                _c(
                  "v-expansion-panels",
                  {
                    attrs: { multiple: "" },
                    model: {
                      value: _vm.panel,
                      callback: function ($$v) {
                        _vm.panel = $$v
                      },
                      expression: "panel",
                    },
                  },
                  _vm._l(_vm.locationPathResult.paths, function (path, index) {
                    return _c(
                      "v-expansion-panel",
                      { key: path.pathId },
                      [
                        _c(
                          "v-expansion-panel-header",
                          { class: { "path-error": _vm.hasFailedRules(path) } },
                          [
                            _c(
                              "div",
                              { staticClass: "path-header" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "primary" },
                                  },
                                  [_vm._v("mdi-electric-switch")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Path " + _vm._s(index + 1))]
                                ),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "ml-3",
                                    attrs: {
                                      small: "",
                                      color: "primary",
                                      outlined: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("mdi-layers-triple")]
                                    ),
                                    _vm._v(
                                      " Depth: " + _vm._s(path.depth) + " "
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      small: "",
                                      color: "info",
                                      outlined: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("mdi-map-marker-path")]
                                    ),
                                    _vm._v(
                                      " Nodes: " +
                                        _vm._s(path.nodes.length) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                                _vm.hasFailedRules(path)
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "ml-2",
                                        attrs: { small: "", color: "error" },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-1",
                                            attrs: { small: "" },
                                          },
                                          [_vm._v("mdi-alert-circle")]
                                        ),
                                        _vm._v(" Rules Failed "),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c("v-expansion-panel-content", [
                          _c(
                            "div",
                            { staticClass: "path-content" },
                            [
                              _c(
                                "v-timeline",
                                { attrs: { "align-top": "" } },
                                _vm._l(path.nodes, function (node, nodeIndex) {
                                  return _c(
                                    "v-timeline-item",
                                    {
                                      key: `${path.pathId}-node-${nodeIndex}`,
                                      attrs: {
                                        color: _vm.getNodeTypeColor(
                                          node.location.type
                                        ),
                                        "fill-dot": "",
                                        right: "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "opposite",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  [
                                                    path.nodes.length - 1 !==
                                                    nodeIndex
                                                      ? _c(
                                                          "v-card",
                                                          {
                                                            staticClass:
                                                              "elevation-2 mr-2",
                                                          },
                                                          [
                                                            _c(
                                                              "v-card-title",
                                                              {
                                                                staticClass:
                                                                  "pb-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Cable Parameters "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-card-text",
                                                              {
                                                                staticClass:
                                                                  "compact-card-content-opposite",
                                                              },
                                                              [
                                                                node.cables &&
                                                                node.cables
                                                                  .length
                                                                  ? _c("div", [
                                                                      _c("p", [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "Unit Cable Capacitance (㎌/m):"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              node
                                                                                .cables[0]
                                                                                .cableCapacitancePerMeter
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]),
                                                                      _c("p", [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "Unit Cable Inductance (mH/m):"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              node
                                                                                .cables[0]
                                                                                .cableInductancePerMeter
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]),
                                                                      _c("p", [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "Cable Length (m):"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              node
                                                                                .cables[0]
                                                                                .cableLength
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]),
                                                                      _c("p", [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "Cable Capacitance (㎌):"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              node
                                                                                .cables[0]
                                                                                .cableCapacitance
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]),
                                                                      _c("p", [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "Cable Inductance (mH):"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              node
                                                                                .cables[0]
                                                                                .cableInductance
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]),
                                                                    ])
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "icon",
                                            fn: function () {
                                              return [
                                                _c("img", {
                                                  staticClass: "timeline-icon",
                                                  attrs: {
                                                    src: _vm.getNodeTypeIcon(
                                                      node.location.type
                                                    ),
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        { staticClass: "elevation-2" },
                                        [
                                          _c(
                                            "v-card-title",
                                            { staticClass: "pb-2" },
                                            [
                                              _c("img", {
                                                staticClass: "node-icon mr-2",
                                                attrs: {
                                                  src: _vm.getNodeTypeIcon(
                                                    node.location.type
                                                  ),
                                                },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(node.location.title) +
                                                  " "
                                              ),
                                              _c(
                                                "v-chip",
                                                {
                                                  staticClass: "ml-2",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: _vm.getNodeTypeColor(
                                                      node.location.type
                                                    ),
                                                    outlined: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(node.location.type)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-chip",
                                                {
                                                  staticClass: "ml-2",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "primary",
                                                    outlined: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " G " +
                                                      _vm._s(
                                                        node.isGasAreaSafe
                                                          ? "Safe"
                                                          : node.gasArea
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-chip",
                                                {
                                                  staticClass: "ml-2",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "primary",
                                                    outlined: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " D " +
                                                      _vm._s(
                                                        node.isDustAreaSafe
                                                          ? "Safe"
                                                          : node.dustArea
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-card-text", [
                                            node.location.type ===
                                            "junction-box"
                                              ? _c("p", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "Junction Box Type:"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.adminDataFieldService.getValueFromOptions(
                                                          "junctionBoxProtectionTechniqueGas",
                                                          node.location
                                                            .junctionBoxDetail
                                                            ?.protectionTechniqueGas
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            node.location.type ===
                                            "junction-box"
                                              ? _c("p", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "Junction Box Dust Type:"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.adminDataFieldService.getValueFromOptions(
                                                          "junctionBoxProtectionTechniqueDust",
                                                          node.location
                                                            .junctionBoxDetail
                                                            ?.protectionTechniqueDust
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-wrap gap-1 mt-3",
                                              },
                                              [
                                                _c(
                                                  "v-card",
                                                  {
                                                    staticClass: "elevation-2",
                                                  },
                                                  [
                                                    _c(
                                                      "v-card-title",
                                                      { staticClass: "pb-2" },
                                                      [_vm._v(" Equipment DB ")]
                                                    ),
                                                    _c(
                                                      "v-card-text",
                                                      {
                                                        staticClass:
                                                          "compact-card-content",
                                                      },
                                                      [
                                                        _c(
                                                          "EquipmentDbComponent",
                                                          {
                                                            attrs: {
                                                              node: node,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-card",
                                                  {
                                                    staticClass: "elevation-2",
                                                  },
                                                  [
                                                    _c(
                                                      "v-card-title",
                                                      { staticClass: "pb-2" },
                                                      [
                                                        _vm._v(
                                                          " Intrinsic Safety Parameters "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-card-text",
                                                      {
                                                        staticClass:
                                                          "compact-card-content",
                                                      },
                                                      [
                                                        _c(
                                                          "IntrinsicSafetyParametersComponent",
                                                          {
                                                            attrs: {
                                                              node: node,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                node.isLoopRulesResults &&
                                                node.isLoopRulesResults.length >
                                                  0
                                                  ? _c(
                                                      "v-card",
                                                      {
                                                        staticClass:
                                                          "elevation-2",
                                                      },
                                                      [
                                                        _c(
                                                          "v-card-title",
                                                          {
                                                            staticClass: "pb-2",
                                                            class:
                                                              _vm.getFailedRules(
                                                                node
                                                              ).length > 0
                                                                ? "error white--text"
                                                                : "success white--text",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "mr-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color:
                                                                    "white",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getFailedRules(
                                                                        node
                                                                      ).length >
                                                                        0
                                                                        ? "mdi-alert-circle"
                                                                        : "mdi-check-circle"
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " IS Loop Rules "
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-card-text",
                                                          {
                                                            staticClass:
                                                              "compact-card-content",
                                                          },
                                                          _vm._l(
                                                            node.isLoopRulesResults,
                                                            function (
                                                              rule,
                                                              ruleIndex
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: ruleIndex,
                                                                  class:
                                                                    !rule.passed
                                                                      ? "rule-error-compact mb-1"
                                                                      : "rule-success-compact mb-1",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      staticClass:
                                                                        "mr-1",
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                        color:
                                                                          !rule.passed
                                                                            ? "error"
                                                                            : "success",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            !rule.passed
                                                                              ? "mdi-close-circle"
                                                                              : "mdi-check-circle"
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-caption",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          !rule.passed
                                                                            ? rule.errorMsg
                                                                            : "Passed"
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }